const CERTIFICATEROUTES = {
    ADDCERTIFICATE: 'certificate/',
    UPDATE: 'certificate/',
    DELETE: 'certificate/:certificateid',
    SPECIFICID: 'certificate/:certificateid',
    ALL: 'certificate/all/certificates'
}

export default CERTIFICATEROUTES;